import moment from "moment";
import { useSnackbar } from "notistack";

const useValidationHook = () => {
    const { enqueueSnackbar } = useSnackbar();
    const checkRatioValidation = (data, interval) => {
        const isDerate = interval?.value === 10 || interval?.value === 11;
        const ratioList = data?.length > 0 ? data?.map(item => isDerate ? item?.derate : item.ratio) : [];
        const ratioMap = new Map();
        const duplicates = [];
        const blankRows = [];
        const blankRateRows = [];
        const blankRateCells = [];
        const errors = {};
        const normalizeValue = (val) => {
            if (val === null || val === undefined || val === "") return "";
            const num = Number(val);
            if (isNaN(num)) return val;
            return num.toString();
        };
        if (interval?.value === 11) {
            const invalidRatioRows = [];
            data.forEach((item, index) => {
                if (!item?.ratios || item?.ratios.length < 2) { invalidRatioRows.push(index); }
            });
            if (invalidRatioRows.length > 0) {
                enqueueSnackbar( `Please add at least two DeRate.`, { variant: "error",hideIconVariant:true, anchorOrigin: { vertical: "top", horizontal: "right" } } );
                return { isValid: false };
            }
            const ratioRowValues = data[0]?.ratios?.map(r => r.ratio) || [];
            const ratioRowMap = new Map();
            const blankRatioRows = [];
            ratioRowValues.forEach((ratioVal, idx) => {
                const normalized = normalizeValue(ratioVal);
                if (normalized === "") {
                    blankRatioRows.push(idx);
                    errors[`ratio_row_${idx}`] = "Please enter the ratio";
                } else if (ratioRowMap.has(normalized)) {
                    const firstIdx = ratioRowMap.get(normalized);
                    errors[`ratio_row_${firstIdx}`] = "Duplicate Ratio";
                    errors[`ratio_row_${idx}`] = "Duplicate Ratio";
                } else {
                    ratioRowMap.set(normalized, idx);
                }
            });
            if (blankRatioRows.length > 0) {
                let blankMessage = `Please enter valid ratio values for the following rows: `;
                blankMessage += blankRatioRows.map(i => `Row ${i + 1}`).join(', ') + '.';
                enqueueSnackbar(blankMessage, { variant: 'error', hideIconVariant: true, anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                return { isValid: false, errors: errors };
            }
        }
        ratioList?.forEach((ratio, index) => {
            const normalizedRatio = normalizeValue(ratio);
            if (normalizedRatio === "") {
                blankRows.push(index);
            } else if (ratioMap.has(normalizedRatio)) {
                const firstIndex = ratioMap.get(normalizedRatio);
                duplicates.push({ ratio, index1: firstIndex, index2: index });
                errors[`row_${firstIndex}`] = "Duplicate Ratio";
                errors[`row_${index}`] = "Duplicate Ratio";
            } else {
                ratioMap.set(normalizedRatio, index);
            }
            if (interval?.value === 11) {
                data[index]?.ratios?.forEach((r, colIndex) => {
                    const rate = r?.rate;
                    if (rate === "" || rate === null || rate === undefined) {
                        blankRateCells.push({ row: index, ratio: r?.ratio });
                        errors[`${index}_${colIndex}`] = "Please enter the rate";
                    } else if (Number(rate) === 0) {
                        blankRateCells.push({ row: index, ratio: r?.ratio });
                        errors[`${index}_${colIndex}`] = "Rate should be greater than 0";
                    }
                });
            }
        });
        interval?.value !== 11 && data?.forEach((item, index) => {
            const rate = item?.rate;
            if (rate === "" || rate === null || rate === undefined) { errors[index] = "Please enter the rate"; blankRateRows.push(index); } 
            else if (Number(rate) === 0) { errors[index] = "Rate should be greater than 0"; blankRateRows.push(index); }
        });
      
        if (data?.length < 2) {
            if (interval?.value === 9) { enqueueSnackbar("Please add at least two Ratio.", { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } }) }
            if (interval?.value === 10) { enqueueSnackbar("Please add at least two DeRate.", { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } }) }
            if (interval?.value === 11) { enqueueSnackbar("Please add at least two Ratio & DeRate.", { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } }) }
            return { isValid: false };
        }
        if (data?.length < 2) {
            let message = "";
            if (interval?.value === 9) { message = "Minimum two Ratio line items are mandatory."; } 
            else if (interval?.value === 10) { message = "Minimum two DeRate line items are mandatory."; } 
            else if (interval?.value === 11) { message = "Minimum two Ratio/DeRate line items are mandatory."; }
            if (message) { enqueueSnackbar(message, { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } }); return { isValid: false }; }
        }
        if (blankRows.length > 0) {
            let blankMessage = `Please enter ${isDerate ? "derate" : "ratio"} values for the following rows: `;
            blankMessage += blankRows.map(i => `Row ${i + 1}`).join(', ') + '.';
            enqueueSnackbar(blankMessage, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
            return { isValid: false };
        }
        if (blankRateRows.length > 0 && interval?.value !== 11) {
            return { isValid: false, errors: errors };
        }
        if (duplicates.length > 0) {
            return { isValid: false, errors: errors };
        }
        if (interval?.value === 11 && blankRateCells.length > 0) {
            return { isValid: false, errors: errors };
        }

        if (interval?.value === 11 && Object.keys(errors).some(k => k.startsWith('ratio_row_'))) {
            return { isValid: false, errors: errors };
        }

        return { isValid: true };
    }
    const checkRangeConditionsValiadation = (data, key, setPbhErrors) => {
        let newErrors = {};
        const showError = (msg) => { enqueueSnackbar(msg, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" } }); };
        const isInterval = data?.rental_type?.value === 4 && data?.rental_rate_based_on?.value === 8;
        const checkRequiredRows = () => {
            if (!Array.isArray(data?.[key]) && data?.[key]?.length > 0) {
                showError("Please add pbh conditions by adding a row");
                return false;
            }
            return true;
        };

        const checkMissingConditions = () => {
            if (!Array.isArray(data?.[key]) && data?.[key]?.length > 0) return true;
            const missing = [];
            if (data?.unit_of_measurement?.value === 4) {
                const fhRows = data?.pbh_conditions?.filter(r => r.unit_of_measure_for?.value === 1);
                const fcRows = data?.pbh_conditions?.filter(r => r.unit_of_measure_for?.value === 2);
                if (!fhRows.some(r => r.range_condition?.value === 1)) missing.push("FH: 'Less Than Equal To'");
                if (!fhRows.some(r => r.range_condition?.value === 3)) missing.push("FH: 'Greater Than Equal To'");
                if (!fcRows.some(r => r.range_condition?.value === 1)) missing.push("FC: 'Less Than Equal To'");
                if (!fcRows.some(r => r.range_condition?.value === 3)) missing.push("FC: 'Greater Than Equal To'");
            } else {
                if (!data?.[key].some(r => r.range_condition?.value === 1)) missing.push("'Less Than Equal To'");
                if (!data?.[key].some(r => r.range_condition?.value === 3)) missing.push("'Greater Than Equal To'");
            }

            if (missing.length) {
                showError(`Missing required ${isInterval ? "Range" : "PBH"} conditions:\n${missing.join(", ")}`);
                return false;
            }
            return true;
        };
        const checkRowErrors = () => {
            data?.[key]?.forEach((row, index) => {
                const errors = {};
                const rangeCond = row.range_condition?.value;

                if (!row.range_condition) errors.range_condition = "Please select Range Condition";
                if (rangeCond === 1 && !row.max_value && row.max_value !== 0) errors.max_value = "Please enter Max Value";
                if (rangeCond === 2) {
                    if (!row.min_value && row.max_value !== 0) { errors.min_value = "Please enter Min Value"; }
                    if (!row.max_value && row.max_value !== 0) { errors.max_value = "Please enter Max Value"; }
                }
                if (rangeCond === 3 && !row.min_value && row.min_value !== 0) errors.min_value = "Please enter Min Value";
                if (row?.rate === "" || row?.rate === null || row?.rate === undefined) {errors.rate = "Please enter the rate";} 
                else if (Number(row?.rate) <= 0) { errors.rate = "Rate should be greater than 0"; }
                if (!row.rate_type && data?.rental_rate_based_on?.value !== 8) errors.rate_type = "Please select Rate Type";
                if (data?.table_based_esc) {
                    const escValue = row?.esc_percentage;
                    const hasEscDate = !!row?.esc_date;
                    if (escValue > 0 && !row?.esc_date) {
                        errors.esc_date = "Please enter Esc Start";
                    } else {
                        delete errors.esc_date;
                    }
                    const escNum = Number(escValue);
                    if (hasEscDate && escNum <= 0) {
                        errors.esc_percentage = "Please enter Escalation";
                    }
                }
                if (data?.start_date && data?.end_date && row?.esc_date) {
                    const esc = moment(row.esc_date);
                    const start = moment(data.start_date);
                    const end = moment(data.end_date);

                    if (esc.isBefore(start)) {
                        errors.esc_date = "Esc date cannot be before Start Date";
                    } else if (esc.isAfter(end)) {
                        errors.esc_date = "Esc date cannot be after End Date";
                    }
                }

                if (Object.keys(errors).length) newErrors[index] = errors;
            });

            setPbhErrors(newErrors);
            return Object.keys(newErrors).length === 0;
        };
        if (data?.table_based_esc && data[key]?.length > 0) {
            if (data?.unit_of_measurement?.value === 4) {
                const fhRows = data?.pbh_conditions?.filter(r => r.unit_of_measure_for?.value === 1);
                const fcRows = data?.pbh_conditions?.filter(r => r.unit_of_measure_for?.value === 2);
                const fhHasEsc = fhRows.some(r => !!r?.esc_date) || fhRows.some(r => Number(r?.esc_percentage) > 0);
                const fcHasEsc = fcRows.some(r => !!r?.esc_date) || fcRows.some(r => Number(r?.esc_percentage) > 0);
                if (!fhHasEsc || !fcHasEsc) {
                    showError("At least one Escalation is required for both FH and FC.");
                    return false;
                }
            } else {
                const hasEsc = data[key].some(r => !!r?.esc_date) || data[key].some(r => Number(r?.esc_percentage) > 0);
                if (!hasEsc) {
                    showError("At least one Escalation is required.");
                    return false;
                }
            }
        }

        const checkMinGreaterThanMax = (rows, label) => {
            const lesserCond = rows.find(r => r.range_condition?.value === 1);
            const betweenCond = rows.find(r => r.range_condition?.value === 2); 
            const greaterCond = rows.find(r => r.range_condition?.value === 3); 
            if (!lesserCond || !greaterCond) return null;
            const min = parseFloat(greaterCond.min_value);
            const max = parseFloat(lesserCond.max_value);
            if (isNaN(min) || isNaN(max)) return null;
            if (betweenCond && min <= max) { return `${label} - Min (Greater Than Equal To) must be greater than Max (Less Than Equal To)`; }
            if (!betweenCond && min < max) { return `${label} - Min (Greater Than Equal To) must be greater than or equal to Max (Less Than Equal To)`; }
            return null;
          };
        const checkRangeMismatch = () => {
            const errors = [];
            if (data?.unit_of_measurement?.value === 4) {
                const fhRows = data?.pbh_conditions?.filter(r => r.unit_of_measure_for?.value === 1);
                const fcRows = data?.pbh_conditions?.filter(r => r.unit_of_measure_for?.value === 2);
                [checkMinGreaterThanMax(fhRows, "FH"), checkMinGreaterThanMax(fcRows, "FC")].forEach(e => e && errors.push(e));
            } else {
                const err = checkMinGreaterThanMax(data?.[key], isInterval ? "Range Condition" : "PBH Condition");
                if (err) errors.push(err);
            }
            if (errors.length) {
                showError(errors.join(" | "));
                return false;
            }
            return true;
        };

        const checkInBetweenRange = (rows, label) => {
            const getMinOfGreaterCond = () =>
                Math.min(...rows?.filter(r => r.range_condition?.value === 3 && !isNaN(parseFloat(r.min_value))).map(r => parseFloat(r.min_value)));

            const getMaxOfLesserCond = () =>
                Math.max(...rows?.filter(r => r.range_condition?.value === 1 && !isNaN(parseFloat(r.max_value))).map(r => parseFloat(r.max_value)));

            const minOfGreater = getMinOfGreaterCond();
            const maxOfLesser = getMaxOfLesserCond();

            return rows?.map((row, idx) => {
                    if (row.range_condition?.value === 2) {
                        const min = parseFloat(row.min_value);
                        const max = parseFloat(row.max_value);
                        if (!isNaN(min) && !isNaN(max)) {
                            if (min >= max) { return `${label} - Row ${idx + 1}: In Between condition Min must be less than Max`; }
                            if (!(min >= maxOfLesser && max <= minOfGreater)) { return `${label} - Row ${idx + 1}: In Between Equal To must lie between Less than Equal To Max and Greater Than Equal To Min`; }
                        }
                    }
                    return null;
                })?.filter(Boolean);
        };

        const checkBetweenConditions = () => {
            const errors = [];
            if (data?.unit_of_measurement?.value === 4) {
                const fhRows = data?.pbh_conditions?.filter(r => r.unit_of_measure_for?.value === 1);
                const fcRows = data?.pbh_conditions?.filter(r => r.unit_of_measure_for?.value === 2);
                errors.push(...checkInBetweenRange(fhRows, "FH"));
                errors.push(...checkInBetweenRange(fcRows, "FC"));
            } else {
                errors.push(...checkInBetweenRange(data?.[key], isInterval ? "Range" : "PBH"));
            }
            if (errors.length) {
                showError(errors.join(" | "));
                return false;
            }
            return true;
        };

        // ---------- Run checks ----------
        if (!checkRequiredRows()) return false;
        if (!checkMissingConditions()) return false;
        if (!checkRowErrors()) return false;
        if (!checkRangeMismatch()) return false;
        if (!checkBetweenConditions()) return false;

        return true;
    };
    return { checkRatioValidation, checkRangeConditionsValiadation }
}

export default useValidationHook